module.exports = __webpack_public_path__ + "img/card_finding_report.38b14862.svg";